import translationKeys from '@translationKeys'

import { ProfileType } from '@modules/search/types'

export const DEFAULT_COMPANY_LOGO_SRC = '/plus/assets/default-company.svg'
export const DEFAULT_ASSET_LOGO_SRC = '/plus/assets/default-asset.svg'
export const DEFAULT_DELEGATE_LOGO_SRC = '/plus/assets/default-delegate.png'

export const ASSETS_OVERVIEW_ORDERED_TABS = [
  ProfileType.biotech,
  ProfileType.medtech,
  ProfileType.technologies,
  ProfileType.services,
]

export const ASSETS_OVERVIEW_TAB_LABELS = {
  [ProfileType.biotech]: translationKeys.LATEST_ASSETS_BIO_TAB,
  [ProfileType.medtech]: translationKeys.LATEST_ASSETS_MED_TAB,
  [ProfileType.technologies]: translationKeys.LATEST_ASSETS_TECH_TAB,
  [ProfileType.services]: translationKeys.LATEST_ASSETS_SERVICE_TAB,
}
